import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mustChangePassword, setMustChangePassword] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('sms_auth');
    if (stored) {
      try {
        const user = JSON.parse(stored);
        setCurrentUser(user);
        if (user.mustChangePassword) setMustChangePassword(true);
      } catch {}
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) return { success: false, error: data.message || 'Invalid email or password' };
      const user = { ...data.user, token: data.token, mustChangePassword: !!data.mustChangePassword };
      setCurrentUser(user);
      setMustChangePassword(!!data.mustChangePassword);
      localStorage.setItem('sms_auth', JSON.stringify(user));
      window.dispatchEvent(new StorageEvent('storage', { key: 'sms_auth' }));
      return { success: true, user, mustChangePassword: !!data.mustChangePassword };
    } catch (e) {
      return { success: false, error: 'Cannot connect to server. Please try again.' };
    }
  };

  const logout = () => {
    setCurrentUser(null);
    setMustChangePassword(false);
    localStorage.removeItem('sms_auth');
  };

  const refreshCurrentUser = (updatedUser) => {
    const user = { ...currentUser, ...updatedUser };
    setCurrentUser(user);
    localStorage.setItem('sms_auth', JSON.stringify(user));
  };

  const clearMustChangePassword = () => {
    setMustChangePassword(false);
    if (currentUser) {
      const user = { ...currentUser, mustChangePassword: false };
      setCurrentUser(user);
      localStorage.setItem('sms_auth', JSON.stringify(user));
    }
  };

  if (loading) return null;

  return (
    <AuthContext.Provider value={{ currentUser, login, logout, refreshCurrentUser, mustChangePassword, clearMustChangePassword }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
